'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var bcodeMap = {
    /** 成功 */
    '0': '%E6%88%90%E5%8A%9F',
    /** 服务端没有配 ui，比如 wupui, webActUI，让对应的服务端处理 */
    '102': '%E6%9C%8D%E5%8A%A1%E7%AB%AF%E6%B2%A1%E6%9C%89%E9%85%8D%20ui%EF%BC%8C%E6%AF%94%E5%A6%82%20wupui%2C%20webActUI%EF%BC%8C%E8%AE%A9%E5%AF%B9%E5%BA%94%E7%9A%84%E6%9C%8D%E5%8A%A1%E7%AB%AF%E5%A4%84%E7%90%86',
    /** 一般是请求体参数错误，找对应的服务端确认哪个参数传错了 */
    '904': '%E4%B8%80%E8%88%AC%E6%98%AF%E8%AF%B7%E6%B1%82%E4%BD%93%E5%8F%82%E6%95%B0%E9%94%99%E8%AF%AF%EF%BC%8C%E6%89%BE%E5%AF%B9%E5%BA%94%E7%9A%84%E6%9C%8D%E5%8A%A1%E7%AB%AF%E7%A1%AE%E8%AE%A4%E5%93%AA%E4%B8%AA%E5%8F%82%E6%95%B0%E4%BC%A0%E9%94%99%E4%BA%86',
    /** 一般是 UserId 结构体的信息传错了，确认下代码，或者去群里问下 */
    '905': '%E4%B8%80%E8%88%AC%E6%98%AF%20UserId%20%E7%BB%93%E6%9E%84%E4%BD%93%E7%9A%84%E4%BF%A1%E6%81%AF%E4%BC%A0%E9%94%99%E4%BA%86%EF%BC%8C%E7%A1%AE%E8%AE%A4%E4%B8%8B%E4%BB%A3%E7%A0%81%EF%BC%8C%E6%88%96%E8%80%85%E5%8E%BB%E7%BE%A4%E9%87%8C%E9%97%AE%E4%B8%8B',
    /** APP 端业务接口超时；或JCE反序列化失败，可能和业务返回码重叠；找服务端或陈伟 */
    '-1': 'APP%20%E7%AB%AF%E4%B8%9A%E5%8A%A1%E6%8E%A5%E5%8F%A3%E8%B6%85%E6%97%B6%EF%BC%9B%E6%88%96JCE%E5%8F%8D%E5%BA%8F%E5%88%97%E5%8C%96%E5%A4%B1%E8%B4%A5%EF%BC%8C%E5%8F%AF%E8%83%BD%E5%92%8C%E4%B8%9A%E5%8A%A1%E8%BF%94%E5%9B%9E%E7%A0%81%E9%87%8D%E5%8F%A0%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** JCE 序列化失败；找服务端或陈伟 */
    '-2': 'JCE%20%E5%BA%8F%E5%88%97%E5%8C%96%E5%A4%B1%E8%B4%A5%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 接口找不到；找服务端或陈伟 */
    '-3': '%E6%8E%A5%E5%8F%A3%E6%89%BE%E4%B8%8D%E5%88%B0%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 找不到 servant；找服务端或陈伟 */
    '-4': '%E6%89%BE%E4%B8%8D%E5%88%B0%20servant%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** JCESERVERRESETGRID；找服务端或陈伟 */
    '-5': 'JCESERVERRESETGRID%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 队列过载；找服务端或陈伟 */
    '-6': '%E9%98%9F%E5%88%97%E8%BF%87%E8%BD%BD%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 业务接口超时；找服务端或陈伟 */
    '-7': '%E4%B8%9A%E5%8A%A1%E6%8E%A5%E5%8F%A3%E8%B6%85%E6%97%B6%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 连接错误；找服务端或陈伟 */
    '-8': '%E8%BF%9E%E6%8E%A5%E9%94%99%E8%AF%AF%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 服务过载；找服务端或陈伟 */
    '-9': '%E6%9C%8D%E5%8A%A1%E8%BF%87%E8%BD%BD%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 服务 servant 为空；找服务端或陈伟 */
    '-10': '%E6%9C%8D%E5%8A%A1%20servant%20%E4%B8%BA%E7%A9%BA%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** set 无效；找服务端或陈伟 */
    '-11': 'set%20%E6%97%A0%E6%95%88%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 未知错误；找服务端或陈伟 */
    '-99': '%E6%9C%AA%E7%9F%A5%E9%94%99%E8%AF%AF%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 触发信令接口频控限制、或ip黑名单；找服务端或陈伟 */
    '-101': '%E8%A7%A6%E5%8F%91%E4%BF%A1%E4%BB%A4%E6%8E%A5%E5%8F%A3%E9%A2%91%E6%8E%A7%E9%99%90%E5%88%B6%E3%80%81%E6%88%96ip%E9%BB%91%E5%90%8D%E5%8D%95%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 信令边缘节点协议解析异常；找服务端或陈伟 */
    '-102': '%E4%BF%A1%E4%BB%A4%E8%BE%B9%E7%BC%98%E8%8A%82%E7%82%B9%E5%8D%8F%E8%AE%AE%E8%A7%A3%E6%9E%90%E5%BC%82%E5%B8%B8%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
    /** 信令边缘节点回源请求核心机房 wup 服务异常；找服务端或陈伟 */
    '-103': '%E4%BF%A1%E4%BB%A4%E8%BE%B9%E7%BC%98%E8%8A%82%E7%82%B9%E5%9B%9E%E6%BA%90%E8%AF%B7%E6%B1%82%E6%A0%B8%E5%BF%83%E6%9C%BA%E6%88%BF%20wup%20%E6%9C%8D%E5%8A%A1%E5%BC%82%E5%B8%B8%EF%BC%9B%E6%89%BE%E6%9C%8D%E5%8A%A1%E7%AB%AF',
};
var sdkcodeMap = {
    /** 成功 */
    '0': '%E6%88%90%E5%8A%9F',
    /** 本地任务超时 */
    '-1': '%E6%9C%AC%E5%9C%B0%E4%BB%BB%E5%8A%A1%E8%B6%85%E6%97%B6',
    /** 本地开始任务失败 */
    '-3': '%E6%9C%AC%E5%9C%B0%E5%BC%80%E5%A7%8B%E4%BB%BB%E5%8A%A1%E5%A4%B1%E8%B4%A5',
    /** 信令未初始化化时请求 */
    '-10': '%E4%BF%A1%E4%BB%A4%E6%9C%AA%E5%88%9D%E5%A7%8B%E5%8C%96%E5%8C%96%E6%97%B6%E8%AF%B7%E6%B1%82',
    /** 首包异常，返回值解释错误 */
    '-500': '%E9%A6%96%E5%8C%85%E5%BC%82%E5%B8%B8%EF%BC%8C%E8%BF%94%E5%9B%9E%E5%80%BC%E8%A7%A3%E9%87%8A%E9%94%99%E8%AF%AF',
    /** socket 发送异常 */
    '-10092': 'socket%20%E5%8F%91%E9%80%81%E5%BC%82%E5%B8%B8',
    /** 解析流消息失败（解包错误） */
    '-10504': '%E8%A7%A3%E6%9E%90%E6%B5%81%E6%B6%88%E6%81%AF%E5%A4%B1%E8%B4%A5%EF%BC%88%E8%A7%A3%E5%8C%85%E9%94%99%E8%AF%AF%EF%BC%89',
    /** 封包错误，请检查 Req 请求体，问题可能出现在 Vector, Map 相关结构体中 */
    '-20001': '%E5%B0%81%E5%8C%85%E9%94%99%E8%AF%AF%EF%BC%8C%E8%AF%B7%E6%A3%80%E6%9F%A5%20Req%20%E8%AF%B7%E6%B1%82%E4%BD%93%EF%BC%8C%E9%97%AE%E9%A2%98%E5%8F%AF%E8%83%BD%E5%87%BA%E7%8E%B0%E5%9C%A8%20Vector%2C%20Map%20%E7%9B%B8%E5%85%B3%E7%BB%93%E6%9E%84%E4%BD%93%E4%B8%AD',
    /** 未注册的接口 */
    '-20002': '%E6%9C%AA%E6%B3%A8%E5%86%8C%E7%9A%84%E6%8E%A5%E5%8F%A3',
    /**  http 请求错误(包括 dns 错误): 连接 taf 信令侧的 http 请求返回异常 */
    '-20003': '%20http%20%E8%AF%B7%E6%B1%82%E9%94%99%E8%AF%AF(%E5%8C%85%E6%8B%AC%20dns%20%E9%94%99%E8%AF%AF)%3A%20%E8%BF%9E%E6%8E%A5%20taf%20%E4%BF%A1%E4%BB%A4%E4%BE%A7%E7%9A%84%20http%20%E8%AF%B7%E6%B1%82%E8%BF%94%E5%9B%9E%E5%BC%82%E5%B8%B8',
};
/**
 * 了解更多:
https://git.huya.com/huyafed/components/huyafed-npm/-/tree/master/packages/taf-network#bcode-%E5%AF%B9%E5%BA%94%E7%9A%84%E7%8A%B6%E6%80%81
https://git.huya.com/huyafed/doc-list/doc/-/issues/25#%E7%8A%B6%E6%80%81%E7%A0%81
 */
var LINK_TIPS = decodeURIComponent("%0A%0A%E4%BA%86%E8%A7%A3%E6%9B%B4%E5%A4%9A%3A%0Ahttps%3A%2F%2Fgit.huya.com%2Fhuyafed%2Fcomponents%2Fhuyafed-npm%2F-%2Ftree%2Fmaster%2Fpackages%2Ftaf-network%23bcode-%25E5%25AF%25B9%25E5%25BA%2594%25E7%259A%2584%25E7%258A%25B6%25E6%2580%2581%0Ahttps%3A%2F%2Fgit.huya.com%2Fhuyafed%2Fdoc-list%2Fdoc%2F-%2Fissues%2F25%23%25E7%258A%25B6%25E6%2580%2581%25E7%25A0%2581%0A%20%20%20%20%20%20%20%20%20%20%20%20");
var SUCCESS_CODE = 0;
/**
 * @description 获取状态码错误信息，成功则返回空字符
 */
var getErrorMsg = function (params) {
    return [
        {
            isError: function () {
                return params.bcode !== undefined && Number(params.bcode) !== SUCCESS_CODE;
            },
            errorMsg: decodeURIComponent("bcode: " + (params === null || params === void 0 ? void 0 : params.bcode) + " " + (bcodeMap[params === null || params === void 0 ? void 0 : params.bcode] || '')),
        },
        {
            isError: function () {
                return params.sdkcode !== undefined && Number(params.sdkcode) !== SUCCESS_CODE;
            },
            errorMsg: decodeURIComponent("sdkcode: " + (params === null || params === void 0 ? void 0 : params.sdkcode) + " " + (sdkcodeMap[params === null || params === void 0 ? void 0 : params.sdkcode] || '')),
        },
    ]
        .filter(function (item) { return item.isError(); })
        .map(function (item) { return item.errorMsg; })
        .join('\n');
};
/**
 * @description 接口状态码检查，错误则打log
 */
var responseCodeChecker = function (params) {
    var _a, _b;
    var errorMsg = getErrorMsg(params.res);
    if (!errorMsg)
        return;
    return ((params === null || params === void 0 ? void 0 : params.logger) || console.error.bind(console))("\u8BF7\u6C42\u5931\u8D25\uFF1A" + ((_a = params === null || params === void 0 ? void 0 : params.reqParams) === null || _a === void 0 ? void 0 : _a.funcName) + "-" + ((_b = params === null || params === void 0 ? void 0 : params.reqParams) === null || _b === void 0 ? void 0 : _b.servant) + "\n    ", errorMsg, LINK_TIPS);
};

exports.LINK_TIPS = LINK_TIPS;
exports.bcodeMap = bcodeMap;
exports.getErrorMsg = getErrorMsg;
exports.responseCodeChecker = responseCodeChecker;
exports.sdkcodeMap = sdkcodeMap;
